import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const Join = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    document.title = 'Join Sparklyt - Career Discovery Waitlist';
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.email || !formData.role) {
      toast.error('Please fill in all required fields');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/waitlist/submit`, {
        name: formData.name || '',
        email: formData.email,
        role: formData.role,
      });

      if (response.data.success) {
        // Redirect based on role
        if (formData.role === 'Parent') {
          navigate('/thank-you-parent');
        } else if (formData.role === 'Student') {
          navigate('/thank-you-student');
        }
      }
    } catch (error) {
      console.error('Submission error:', error);
      toast.error('Something went wrong. Please try again.');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="join-page">
      <div className="container">
        <div className="join-content">
          <div className="join-header">
            <h1 className="hero-medium">Join Sparklyt</h1>
            <p className="body-large text-secondary">
              Tell us who you are and we'll keep you updated as we build.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="join-form">
            <div className="form-group">
              <Label htmlFor="name" className="body-regular">Name (optional)</Label>
              <Input
                id="name"
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="form-input"
                placeholder="Your name"
              />
            </div>

            <div className="form-group">
              <Label htmlFor="email" className="body-regular">
                Email <span className="text-error">*</span>
              </Label>
              <Input
                id="email"
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="form-input"
                placeholder="your@email.com"
              />
            </div>

            <div className="form-group">
              <Label htmlFor="role" className="body-regular">
                I am a <span className="text-error">*</span>
              </Label>
              <Select
                value={formData.role}
                onValueChange={(value) => setFormData({ ...formData, role: value })}
                required
              >
                <SelectTrigger className="form-select">
                  <SelectValue placeholder="Select your role" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Parent">Parent</SelectItem>
                  <SelectItem value="Student">Student</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <Button 
              type="submit" 
              className="btn-primary btn-submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Request Early Access'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Join;
